import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { onboardingSelectors } from "../../onboarding/onboarding.selectors";
import { onfidoApi } from "../api";
import { ERROR_CODES, ONFIDO_KEYS } from "../constants";
import {
  OnfidoData,
  TFirstDocument,
  TOnfidoSavePayload,
  TSecondDocument,
  TVideo,
} from "../types";

export const saveOnfidoData = createAsyncThunk<
  void,
  {
    onfidoData: OnfidoData;
  }
>("onfido/GET_NEXT_ONFIDO_PHASE", async (data, thunkApi) => {
  const { dispatch, rejectWithValue, getState } = thunkApi;
  const state = getState() as RootState;
  const { onfidoData } = data;
  const onboardingStepData = onboardingSelectors.data(state);
  const processId = onboardingStepData?.processId;
  const results: TOnfidoSavePayload[] = [];
  try {
    const { face, document_front, document_back } = onfidoData;
    if (processId) {
      if (face) {
        const res: TVideo = {
          processId,
          docType: ONFIDO_KEYS.VIDEO_CAPTCHA,
          type: face.variant,
          face: {
            id: face.id,
            variant: face.variant,
          },
        };
        results.push(res);
      }
      if (document_front) {
        const docType =
          document_front.type === "residence_permit"
            ? ONFIDO_KEYS.OCR_DOCUMENTO_2
            : ONFIDO_KEYS.OCR_DOCUMENTO;
        const res: TFirstDocument | TSecondDocument = {
          processId,
          docType,
          type: ONFIDO_KEYS.DOCUMENT,
          document_front: {
            ...document_front,
            side: ONFIDO_KEYS.FRONT,
          },
          ...(document_back
            ? {
                document_back: {
                  ...document_back,
                  side: ONFIDO_KEYS.BACK,
                },
              }
            : {}),
        };
        results.push(res);
      }
    }
    for (const upload of results) {
      const res = await dispatch(onfidoApi.endpoints.save.initiate(upload));
      if (Object.prototype.hasOwnProperty.call(res, "error")) {
        return rejectWithValue(ERROR_CODES.SAVE_ERROR);
      }
    }
  } catch (err) {
    return rejectWithValue(ERROR_CODES.SAVE_ERROR);
  }
});
